"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const ethers_1 = require("ethers");
const onchainTypes_1 = require("../onchainTypes");
const weths_1 = require("../../config/contracts/weths");
const general_1 = require("../../config/general");
const MAX_UINT256 = ethers_1.ethers.constants.MaxUint256;
const EIP712DOMAIN = [
    { name: "name", type: "string" },
    { name: "version", type: "string" },
    { name: "chainId", type: "uint256" },
    { name: "verifyingContract", type: "address" },
];
const PERMIT = [
    { name: "owner", type: "address" },
    { name: "spender", type: "address" },
    { name: "value", type: "uint256" },
    { name: "nonce", type: "uint256" },
    { name: "deadline", type: "uint256" },
];
const TYPES = {
    EIP712Domain: EIP712DOMAIN,
    Permit: PERMIT,
    BorrowPermit: PERMIT,
};
class OnchainInteractionsPoolToken {
    constructor() {
        this.getPoolToken = () => this.poolToken;
        // Shortcuts
        this.getAccountAddress = () => this.getInteractions().getAccountAddress();
        this.getOnchain = () => this.getInteractions().getOnchain();
    }
    send(method, onTransactionHash, value) {
        return this.getInteractions().send(method, onTransactionHash, value);
    }
    //send = this.getInteractions().send;
    getOwnerSpender() {
        return {
            owner: this.getAccountAddress(),
            spender: this.getRouterContract()._address,
        };
    }
    isWETH() {
        return __awaiter(this, void 0, void 0, function* () {
            const token = yield this.poolToken.getToken();
            return token._address.toLowerCase() == weths_1.WETH[this.getOnchain().network].toLowerCase();
        });
    }
    getAllowance(approvalType) {
        return __awaiter(this, void 0, void 0, function* () {
            const poolToken = yield this.poolToken.getPoolToken();
            const token = yield this.poolToken.getToken();
            if ((yield this.isWETH()) && approvalType == onchainTypes_1.ApprovalType.UNDERLYING)
                return MAX_UINT256;
            const { owner, spender } = this.getOwnerSpender();
            const allowance = (approvalType == onchainTypes_1.ApprovalType.POOL_TOKEN) ? yield poolToken.methods.allowance(owner, spender).call() :
                (approvalType == onchainTypes_1.ApprovalType.UNDERLYING) ? yield token.methods.allowance(owner, spender).call() :
                    (approvalType == onchainTypes_1.ApprovalType.BORROW) ? yield poolToken.methods.borrowAllowance(owner, spender).call() : 0;
            return ethers_1.BigNumber.from(allowance);
        });
    }
    approve(approvalType, amount, onTransactionHash) {
        return __awaiter(this, void 0, void 0, function* () {
            const { spender } = this.getOwnerSpender();
            const poolToken = yield this.poolToken.getPoolToken();
            const token = yield this.poolToken.getToken();
            let method;
            if (approvalType == onchainTypes_1.ApprovalType.POOL_TOKEN)
                method = poolToken.methods.approve(spender, amount);
            if (approvalType == onchainTypes_1.ApprovalType.UNDERLYING)
                method = token.methods.approve(spender, amount);
            if (approvalType == onchainTypes_1.ApprovalType.BORROW)
                method = poolToken.methods.borrowApprove(spender, amount);
            return this.send(method, onTransactionHash);
        });
    }
    _getPermitData(approvalType, amount, deadlineArg, callBack) {
        return __awaiter(this, void 0, void 0, function* () {
            const { owner, spender } = this.getOwnerSpender();
            const poolToken = yield this.poolToken.getPoolToken();
            const token = yield this.poolToken.getToken();
            const contract = approvalType == onchainTypes_1.ApprovalType.UNDERLYING ? token : poolToken;
            const nonce = yield contract.methods.nonces(owner).call();
            const name = yield contract.methods.name().call();
            const deadline = deadlineArg ? deadlineArg : general_1.DEADLINE;
            const data = JSON.stringify({
                types: TYPES,
                domain: {
                    name: name,
                    version: "1",
                    chainId: this.getOnchain().chainId,
                    verifyingContract: contract._address,
                },
                primaryType: approvalType == onchainTypes_1.ApprovalType.BORROW ? "BorrowPermit" : "Permit",
                message: {
                    owner: owner,
                    spender: spender,
                    value: amount.toString(),
                    nonce: ethers_1.BigNumber.from(nonce).toHexString(),
                    deadline: deadline.toNumber(),
                }
            });
            this.getOnchain().web3.currentProvider.send({
                method: "eth_signTypedData_v4",
                params: [owner, data],
                from: owner
            }, (err, data) => {
                if (err) {
                    console.error(err);
                    return callBack(null);
                }
                const signature = data.result.substring(2);
                const r = "0x" + signature.substring(0, 64);
                const s = "0x" + signature.substring(64, 128);
                let v = parseInt(signature.substring(128, 130), 16);
                if (v == 0 || v == 1)
                    v = v + 27;
                //console.log(v, r, s);
                const permitData = ethers_1.ethers.utils.defaultAbiCoder.encode(['bool', 'uint8', 'bytes32', 'bytes32'], [false, v, r, s]);
                callBack({ permitData, deadline, amount });
            });
        });
    }
    getPermitData(approvalType, amount, deadlineArg, callBack) {
        return __awaiter(this, void 0, void 0, function* () {
            if (approvalType === onchainTypes_1.ApprovalType.UNDERLYING)
                return callBack(null);
            this._getPermitData(approvalType, amount, deadlineArg, callBack);
        });
    }
    getSendData(permitData) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                router: this.getRouterContract(),
                ptAddress: (yield this.poolToken.getPoolToken())._address,
                account: this.getInteractions().getAccountAddress(),
                data: permitData ? permitData.permitData : '0x',
                deadline: permitData ? permitData.deadline : general_1.DEADLINE,
            };
        });
    }
    mintETH(amount, permitData, onTransactionHash) {
        return __awaiter(this, void 0, void 0, function* () {
            const { router, ptAddress, account, deadline } = yield this.getSendData(permitData);
            return this.send(router.methods.mintETH(ptAddress, account, deadline), onTransactionHash, amount);
        });
    }
    mint(amount, permitData, onTransactionHash) {
        return __awaiter(this, void 0, void 0, function* () {
            const { router, ptAddress, account, deadline } = yield this.getSendData(permitData);
            return this.send(router.methods.mint(ptAddress, amount, account, deadline), onTransactionHash);
        });
    }
    ;
    deposit(amount, permitData, onTransactionHash) {
        return __awaiter(this, void 0, void 0, function* () {
            if (yield this.isWETH()) {
                return this.mintETH(amount, permitData, onTransactionHash);
            }
            else {
                return this.mint(amount, permitData, onTransactionHash);
            }
        });
    }
    withdraw(tokens, permitData, onTransactionHash) {
        return __awaiter(this, void 0, void 0, function* () {
            const { router, ptAddress, account, data, deadline } = yield this.getSendData(permitData);
            if (yield this.isWETH()) {
                return this.send(router.methods.redeemETH(ptAddress, tokens, account, deadline, data), onTransactionHash);
            }
            else {
                return this.send(router.methods.redeem(ptAddress, tokens, account, deadline, data), onTransactionHash);
            }
        });
    }
}
exports.default = OnchainInteractionsPoolToken;
